import React, {
  useState,
  useRef,
  useContext,
  Fragment,
  useEffect,
} from "react";
import MassageBox from "./MassageBox";
import AuthContext from "../../context/auth/authContext";
import VideoContext from "../../context/video/videoContext";
import { timestamp } from "../../firebase/config";
import "../../styles/fonts.css";
import Spinner from "./Spinner";

const CommentBox = (props) => {
  const videoContext = useContext(VideoContext);
  const { comments, resource } = videoContext;

  const authContext = useContext(AuthContext);
  const { addError, currentUser } = authContext;

  const commentInput = useRef("");
  const updateComment = (event) => {
    event.preventDefault();
    if (commentInput.current.value === "") {
      addError("No comment Given");
    } else if (!currentUser) {
      addError("Log in to comment");
    } else {
      let Newcomment = {
        UserName: currentUser.displayName,
        UserProfile: currentUser.photoURL,
        createdAt: timestamp(),
        body: commentInput.current.value,
        resourceid: props.match.params.id,
        userid: currentUser.uid,
      };
      videoContext.addComment(Newcomment);
    }
    commentInput.current.value = "";
  };

  return (
    <Fragment>
      <div className='card bg-light p-1'>
        <div className='card-body'>
          <form>
            <div className='form-group row'>
              <h3 className='text-center titlefont m-2'>
                <label htmlFor='exampleFormControlInput1'>
                  Give your message!!
                </label>
              </h3>
              <div className='input-group mb-3 mt-4 '>
                <input
                  type='text'
                  className='form-control simplefont'
                  placeholder='Comment...'
                  ref={commentInput}
                />{" "}
                <div className='input-group-append'>
                  <button
                    id='Commentbutton'
                    type='submit'
                    className='btn btn-dark'
                    onClick={updateComment}
                  >
                    <i className='far fa-share-square'></i>
                  </button>{" "}
                </div>
              </div>
            </div>
          </form>

          {comments &&
            comments.map((val, index) => (
              <MassageBox
                key={index}
                Name={val.UserName}
                img={val.UserProfile}
                body={val.body}
                userid={val.userid}
                commentid={val.commentid}
                replies={val.replies}
              />
            ))}
        </div>
      </div>
    </Fragment>
  );
};

export default CommentBox;
